
import { OpenReactConfirmationDialogChannel } from '@tableau/omnibox-common/lib/src/channelDefinitions/OpenReactConfirmationDialogChannel';
import { RecentApiResponseExtractChannel, RecentsUsersExtractChannel } from '@tableau/omnibox-common/lib/src/channelDefinitions/RecentsAPIChannels';
import { UsersWithProfilePicsExtractChannel } from '@tableau/omnibox-common/lib/src/channelDefinitions/UsersWithProfilePicsExtractChannel';

import { openReactConfirmationDialog, ReactConfirmationDialogOptions } from '~src/commonInfra/dialogs/ReactConfirmationDialog';
import { recentsSpaceDefaultSortOrder } from '~src/recents/models/RecentsSortOptions';
import { Users } from '~src/userManagement/services/resources/Users';

import {
    Recents
} from '../../recents/resources/Recents';

export function startListening(): () => void {
    const unsubscribeRecentsUsersExtractChannel = startListeningToRecentsUsersExtractChannel();
    const unsubscribeRecentApiResponseExtractChannel = startListeningToRecentApiResponseExtractChannel();
    const unsubscribeUsersWithProfilePicsChannel = startListeningToUsersWithProfilePicsChannel();
    const unsubscribeOpenReactConfirmationDialogChannel = startListeningToOpenReactConfirmationDialogChannel();
    return () => {
        unsubscribeRecentsUsersExtractChannel();
        unsubscribeRecentApiResponseExtractChannel();
        unsubscribeUsersWithProfilePicsChannel();
        unsubscribeOpenReactConfirmationDialogChannel();
    };
}

export function startListeningToRecentsUsersExtractChannel(): () => void {
    const recentsUsersExtractChannel = new RecentsUsersExtractChannel();
    return recentsUsersExtractChannel.listen((availableRecentsSupportedContentTypes) => {
        return { recentUsers: Recents.users(availableRecentsSupportedContentTypes)};
    });
}

export function startListeningToRecentApiResponseExtractChannel(): () => void {
    const recentApiResponseExtractChannel = new RecentApiResponseExtractChannel();
    return recentApiResponseExtractChannel.listen((explorableItemTypes: any) => {
        const recentApiResponse = Recents.all(explorableItemTypes).withOrder(recentsSpaceDefaultSortOrder).getSlice(0, 20);
        return { recentApiResponse: recentApiResponse };
    });
}

export function startListeningToUsersWithProfilePicsChannel(): () => void {
    const usersWithProfilePicsChannel = new UsersWithProfilePicsExtractChannel();
    return usersWithProfilePicsChannel.listen((ids: string[]) => {
        return { usersWithProfilePics: Users.instance.getUsersById(ids) };
    });
}

export function startListeningToOpenReactConfirmationDialogChannel(): () => void {
    const channel = new OpenReactConfirmationDialogChannel();
    return channel.listen((r: ReactConfirmationDialogOptions<void, void>) => {
        const dialog = openReactConfirmationDialog<void, void>(r);
        return { dialog: dialog };
    });
}
